import { render, staticRenderFns } from "./BetgameDelete.vue?vue&type=template&id=f37e53a0&scoped=true"
import script from "./BetgameDelete.vue?vue&type=script&lang=js"
export * from "./BetgameDelete.vue?vue&type=script&lang=js"
import style0 from "./BetgameDelete.vue?vue&type=style&index=0&id=f37e53a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f37e53a0",
  null
  
)

export default component.exports